import { render, staticRenderFns } from "./Impactstatus.vue?vue&type=template&id=32d50b1c&"
import script from "./Impactstatus.vue?vue&type=script&lang=js&"
export * from "./Impactstatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports